export default "__VITE_ASSET__CtBM9$Nz__"